export const photos = [
  {
    src: "https://drive.google.com/thumbnail?id=1QmoKFu4ublgLwbZ9mw6c4HArYyPYxfen&sz=w2000",
    width: 4,
    height: 3
  },
  {
    src: "https://drive.google.com/thumbnail?id=1EGOyK_6mpI6mG76EPWoGhvrm9Yl0qFNL&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1z-IQ-qHUqzU4ESBj1vsTzsAsL5rI4hlt&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1yxtTkD9kodVLMfHgMRE444vz7J0-SW0Y&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1XxHxXtHBfbgyvhgx_a4C8qmbTIzxSPsz&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=13Bhm6GFxNDHAVU2fTHi0qUcQin-8RwCg&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1lIK_8SSU8DtffRv7FMwWWDdRQzasXKTL&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1gFA0C6fe8XwQOP7UtC2Wep703XGITn-j&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1DOmW9KObx63c0DFGTBg3jWHg3Fi0DeMB&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1hCnR7SroI41xV9k893kzV7DD_E1zC38e&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1hZNByMfoKgEVgubewelDmm2xaQ--ow56&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1mH_FgaVFSdaKANnO41lvmWzTAfz283S1&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1kEJ7gMyQnx1cL_PEd5f_DONQYn5NN38H&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=12TBAr4Bwwr3YMK5Fqi8rzA60XxizNdl9&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1vgIvUquDh7UlqsMel4JKd1oNI37YHDQD&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1Swvv0Ro8ivL0R793NQxPCXnVMFubB8Jh&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1j6MOtht7JHB3zSNxkhBF-YvlFfHO_rUw&sz=w2000",
    width: 4,
    height: 3
  },
  {
    src: "https://drive.google.com/thumbnail?id=1THyqUunjNILYXOsF_sGmzpwFax5YNVPe&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1hv6CHgHQTfy4KY-DOfl83FTrHWztASym&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1yaCuVAzJleJ_yOtVX-cyz1BzoZw_koX9&sz=w2000",
    width: 4,
    height: 3
  },
  {
    src: "https://drive.google.com/thumbnail?id=1iAgMLcWMe6dYFa1vLWOhUi56Ntlw0C_g&sz=w1000",
    width: 3,
    height: 4
  },
  {
    src: "https://drive.google.com/thumbnail?id=1gFA0C6fe8XwQOP7UtC2Wep703XGITn-j&sz=w1000",
    width: 3,
    height: 4
  },
];



// WEBPACK FOOTER //
// ./src/photos.js